import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

// Initialize Sentry for production
if (import.meta.env.VITE_SENTRY_DSN && import.meta.env.PROD) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    environment: import.meta.env.MODE,
  });
}

// Development: Disable offline system
if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
  console.log("🔧 Development: Offline system disabled");
} else {
  // Production: Enable offline system
  try {
    Promise.all([
      import("./utils/offlineMessaging").then(({ offlineMessaging }) =>
        offlineMessaging.init().catch(() => console.log('Offline messaging fallback'))
      ),
      import("./utils/productionSW").then(({ productionSW }) =>
        productionSW.init().catch(() => console.log('Production SW fallback'))
      ),
    ]).then(() => {
      console.log("🌐 AgroSense: Offline system ready");
    });
  } catch (error) {
    console.log("🔧 AgroSense: Offline system unavailable");
  }
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

try {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
} catch (error) {
  console.error('App failed to render:', error);
  rootElement.innerHTML = '<div style="padding:2rem;text-align:center;"><h1>AgroSense</h1><p>Loading error. Please refresh the page.</p></div>';
}
